import { memo, useEffect, useState } from 'react';
import { StyleTextInput } from './StyleTextInput';

/**
 * A number field: the text typed stays as typed (`-`, `1.`) while the
 * value moves on with every complete number; blank is no value.
 */
export const StyleNumberInput = memo(
  ({
    label,
    value,
    placeholder,
    onChange,
  }: {
    label: string;
    value: number | undefined;
    placeholder?: string;
    onChange: (value: number | undefined) => void;
  }) => {
    const [text, setText] = useState(value === undefined ? '' : String(value));
    useEffect(() => {
      setText(current =>
        Number(current) === value || (current === '' && value === undefined)
          ? current
          : value === undefined
          ? ''
          : String(value),
      );
    }, [value]);
    return (
      <StyleTextInput
        label={label}
        value={text}
        placeholder={placeholder}
        numeric
        maxLength={16}
        onChange={next => {
          setText(next);
          const trimmed = next.trim();
          if (!trimmed) onChange(undefined);
          else if (Number.isFinite(Number(trimmed))) onChange(Number(trimmed));
        }}
      />
    );
  },
);
